/**
 * Preço da oferta do parceiro com centavos, no formato do texto da condição ("R$ 239,00", "R$ 99,90"), que vem pronto
 * do servidor (`Dashboard/shared/texto-da-condicao.ts`). Antes a página arredondava ("R$100") e a mesma tela mostrava
 * dois preços para R$ 99,90 (revisão de 18/10/2026). Formatador no módulo (§C10); o Intl separa "R$" do número com
 * espaço não separável, e o texto da condição usa o espaço comum.
 */
const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const reaisComCentavos = (centavos: number): string => BRL.format(centavos / 100).replace(/\s/g, " ");
